module.exports = __webpack_public_path__ + "static/media/banner3.8fbdc9bc.jpg";